import {createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {t} from "i18next";
import {ResponseApi} from "../BaseApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


const serviceTypeSectionSlice = createSlice({
    name: 'serviceTypeSection',
    initialState: {
        getAllServiceType: {},
        createServiceType: {},
        updateServiceType: {},
        deleteServiceType: {},
        listOfUsersServiceType: {},
        getAllNonServicetypeUser: [],

    },
    reducers: {},
    extraReducers: {
        'serviceTypeSection/getAllServiceType/fulfilled': (state, action) => {
            state.getAllServiceType = ResponseApi(action.payload)
        },
        'serviceTypeSection/createServiceType/fulfilled': (state, action) => {
             state.createServiceType = ResponseApi(action.payload)
        },
        'serviceTypeSection/updateServiceType/fulfilled': (state, action) => {
             state.updateServiceType = ResponseApi(action.payload)
        },
        'serviceTypeSection/deleteServiceType/fulfilled': (state, action) => {
             state.deleteServiceType = ResponseApi(action.payload)
        },
        'serviceTypeSection/listOfUsersServiceType/fulfilled': (state, action) => {
            state.listOfUsersServiceType = ResponseApi(action.payload)
        },
        'serviceTypeSection/getAllNonServicetypeUser/fulfilled': (state, action) => {
            state.getAllNonServicetypeUser = ResponseApi(action.payload)
        },
    },
});

export const {} = serviceTypeSectionSlice.actions;

export default serviceTypeSectionSlice.reducer;
